import { Pipe, PipeTransform } from '@angular/core';
import { DataService } from '../services/data.service'
@Pipe({
    name: 'itemFilter'
})
export class ItemFilterPipe implements PipeTransform {
    /* transform(items: Array<any>, filter: { [key: string]: any }): Array<any> {
         if (!items) return [];
         if (filter) return items
         if (filter.Name == '' || filter.Name == null) return [];
         return items.filter(e => e[filter.Name].toLowerCase().indexOf(filter.Name) > -1);
     } */
    /* transform(items: any[], value: string, label: string): any[] {
         if (!items) return [];
         if (!value) return items;
         if (value == '' || value == null) return [];
         return items.filter(e => e[label].toLowerCase().indexOf(value) > -1);
 
     }*/
    constructor(private ds: DataService) {

    }
    transform(items: any[], Barcode: string, Name: string, RefNo: string, Supplier: string, Cost: string, Seling: string, Unit: string, Code: String, VRNNo: string, CategoryName: string, PrinterName: string, Company: string, Branch: string, Location: string, INVNO: string, INVDATE: string) {
        // items = this.ds.ItemDetails.data;
        if (items && items.length) {
            return items.filter(item => {
                if (Barcode && item.Barcode.toLowerCase().indexOf(Barcode.toLowerCase()) === -1) {
                    return false;
                }
                if (Name && item.Name.toLowerCase().indexOf(Name.toLowerCase()) === -1) {
                    return false;
                }
                if (RefNo && item.RefNo.toLowerCase().indexOf(RefNo.toLowerCase()) === -1) {
                    return false;
                }
                if (Supplier && item.SupplierName.toLowerCase().indexOf(Supplier.toLowerCase()) === -1) {
                    return false;
                }
                if (Cost && item.CostPrice.toString().toLowerCase().indexOf(Cost.toString().toLowerCase()) === -1) {
                    return false;
                }
                if (Seling && item.SellingPrice.toString().toLowerCase().indexOf(Seling.toString().toLowerCase()) === -1) {
                    return false;
                }
                if (Unit && item.Unit.toString().toLowerCase().indexOf(Unit.toString().toLowerCase()) === -1) {
                    return false;
                } if (Code && item.Code.toString().toLowerCase().indexOf(Code.toString().toLowerCase()) === -1) {
                    return false;
                }
                if (VRNNo && item.VRNNo.toString().toLowerCase().indexOf(VRNNo.toString().toLowerCase()) === -1) {
                    return false;
                }
                if (CategoryName && item.CategoryName.toString().toLowerCase().indexOf(CategoryName.toString().toLowerCase()) === -1) {
                    return false;
                }
                if (PrinterName && item.PrinterName.toString().toLowerCase().indexOf(PrinterName.toString().toLowerCase()) === -1) {
                    return false;
                }
                if (Company && item.Company.toString().toLowerCase().indexOf(Company.toString().toLowerCase()) === -1) {
                    return false;
                }
                if (Branch && item.Branch.toString().toLowerCase().indexOf(Branch.toString().toLowerCase()) === -1) {
                    return false;
                }
                if (Location && item.Location.toString().toLowerCase().indexOf(Location.toString().toLowerCase()) === -1) {
                    return false;
                }
                if (INVNO && item.INVNO.toString().toLowerCase().indexOf(INVNO.toString().toLowerCase()) === -1) {
                    return false;
                }
                if (INVDATE && item.INVDATE.toString().toLowerCase().indexOf(INVDATE.toString().toLowerCase()) === -1) {
                    return false;
                }
                return true;
            })
        }
        else {
            return items //this.ds.ItemDetails.data;
        }
    }
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/pipe/itemFilter.pipe.ts